import React, { useEffect, useState } from 'react';
import { decodeBookingToken } from '../../libs/bookingToken';
import { charterModelData } from '../../services/ModelService';
import styled from 'styled-components';

const Container = styled.div`
  min-height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
  padding: 20px;
`;

const Card = styled.div`
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 400px;
  width: 100%;
`;

const Icon = styled.div`
  font-size: 48px;
  margin-bottom: 1rem;
`;

const Title = styled.h1`
  font-size: 24px;
  color: #2d3748;
  margin-bottom: 1rem;
`;

const Message = styled.p`
  font-size: 16px;
  color: ${props => props.error ? '#e53e3e' : '#4a5568'};
  margin-bottom: 1.5rem;
  line-height: 1.5;
`;

const LoadingSpinner = styled.div`
  border: 3px solid #f3f3f3;
  border-top: 3px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

function ConfirmBooking() {
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
  const [decoded, setDecoded] = useState(null);

  useEffect(() => {
    async function decode() {
        const params = new URLSearchParams(window.location.search);
        const token = params.get('token');
        if (!token) {
          setStatus('error');
          setMessage('No confirmation token found.');
          return;
        }
        const decoded = await decodeBookingToken(token);
        console.log('decoded', decoded);
        setDecoded(decoded);
        setStatus('decoded');
    }
    decode().then(() => {
        console.log('decoded', decoded);
    });
  }, []);

  useEffect(() => {
    if(decoded === null) return;
    if (status == 'decoded' && (!decoded || !decoded.charterId || !decoded.userId)) {
      setStatus('error');
      setMessage('Invalid or expired confirmation token.');
      return;
    }

    setStatus('loading');
    // POST the decoded values to the backend
    charterModelData.confirmBooking(decoded)
      .then(() => {
        setStatus('success');
        setMessage('We’ll reach out soon to lock everything in.');
      })
      .catch((err) => {
        setStatus('error');
        setMessage('There was a problem confirming your booking. Please try again or contact support.');
      });
  }, [decoded]);

  if (status === 'loading') {
    return (
      <Container>
        <Card>
          <LoadingSpinner />
          <Title>Processing...</Title>
          <Message>Please wait while we send your request</Message>
        </Card>
      </Container>
    );
  }

  if (status === 'success') {
    return (
      <Container>
        <Card>
          <Icon>✅</Icon>
          <Title>Thanks for accepting!</Title>
          <Message>{message}</Message>
        </Card>
      </Container>
    );
  }

  return (
    <Container>
      <Card>
        <Icon>❌</Icon>
        <Title>Oops! Something went wrong</Title>
        <Message error>{message}</Message>
      </Card>
    </Container>
  );
}

export default ConfirmBooking; 